"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactBlueprintLibrary = require("react-blueprint-library");
var _utils = require("../../utils");
var _imageSrc = require("../../lib/imageSrc");
var _richTextField = require("../../lib/richTextField");
var _lodash = require("lodash");
var _reactBootstrap = require("react-bootstrap");
var _titleHeadTag = require("../../lib/titleHeadTag");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 *  A react component to create a call out horizontal card
 *
 * @param {object} props The properties passed into the object
 * @param {object} props.rendering Fields to render
 * @param {object} props.rendering.fields Fields
 *
 * @returns {React.ReactElement} A call out horizontal card
 */
function CallOutCard(props) {
  if (!props.rendering.fields) return null;
  var extractedFields = (0, _utils.extractFieldsFn)(props);
  var sideColumnDirection = extractedFields.ColumnPlacement.value;
  var CardImage = extractedFields => {
    if (!(0, _lodash.isEmpty)(extractedFields.Image.value)) {
      if (extractedFields.TransformImageRound.value) {
        return /*#__PURE__*/_react.default.createElement("picture", {
          className: "mm-img-circle--xl"
        }, /*#__PURE__*/_react.default.createElement("img", {
          src: (0, _imageSrc.imageHref)(extractedFields.Image.value),
          alt: extractedFields.Image.value.alt
        }));
      } else {
        return /*#__PURE__*/_react.default.createElement("img", {
          src: (0, _imageSrc.imageHref)(extractedFields.Image.value),
          alt: extractedFields.Image.value.alt
        });
      }
    } else return null;
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "app-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "card--basic no-border card"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-4 ".concat(sideColumnDirection === 'left' ? 'order-first' : 'order-last')
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Body, null, !(0, _lodash.isEmpty)(extractedFields.Eyebrow.value) && /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Label, null, extractedFields.Eyebrow.value), !(0, _lodash.isEmpty)(extractedFields.Title.value) && (0, _titleHeadTag.headTagTitle)(extractedFields.Title, 'card-title', extractedFields.TitleSize.value), !(0, _lodash.isEmpty)(extractedFields.PreviewText.value) && /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Text, null, (0, _richTextField.parseHTML)(extractedFields.PreviewText)), /*#__PURE__*/_react.default.createElement(CardImage, extractedFields))), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-8 ".concat(sideColumnDirection === 'left' ? 'order-last' : 'order-first')
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Body, null, !(0, _lodash.isEmpty)(extractedFields.BodyText.value) && /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Text, null, (0, _richTextField.parseHTML)(extractedFields.BodyText)))))));
}
var _default = exports.default = CallOutCard;